<app-layout class="container--md">
    <div>
        <div class="wentWrong__content-container">
            <div class="wentWrong__left">
                <img src="/assets/images/something-went-wrong-illustration.svg" alt="connection lost">
            </div>
            <div class="wentWrong__right">
                <h1>Something went wrong</h1>
                <p><span class="link" (click)="goBack()">Click here</span> to return to the previous page.</p>
                <p>If this problem persists, please contact PMM helpdesk.</p>
            </div>
        </div>
    </div>
</app-layout>